const apiEndpoint = 'https://jts-api.docker.localhost/';
// const apiEndpoint = 'https://dev-jts-api.staging.stonecode.io/';
// const apiEndpoint = 'https://demo-jts-api.staging.stonecode.io/';
// const apiEndpoint = 'https://preproduction-jts-api.staging.stonecode.io/';
// const apiEndpoint = 'https://api.japan-expo.com/';

// const mercureEndpoint = 'https://jts-mercure.docker.localhost/';
// const mercureEndpoint = 'https://dev-jts-mercure.staging.stonecode.io/';
const mercureEndpoint = 'https://preproduction-jts-api.staging.stonecode.io/';

if ( !window.APP_CONFIG ) {
	window.APP_CONFIG = {
      services: [
        {
          '@id': 'fondations',
          '@type': 'service',
          '@urn': 'jts.registry.service.fondations',
          'id': 'fondations',
          'name': 'Fondations',
          'description': '',
          'url': 'https://dev-jts-fondations.staging.stonecode.io/',
          'color': '#751265',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M1.778 0h12.444v1.777H1.778zM12.543 2.568H3.654a.887.887 0 100 1.777h8.889a.888.888 0 100-1.777zM9.877 5.333h1.778V16H9.877zM7.111 5.333h1.778V16H7.111zM4.543 5.333H6.32V16H4.543z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'fondations',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'rh',
          '@type': 'service',
          '@urn': 'jts.registry.service.rh',
          'id': 'rh',
          'name': 'RH',
          'description': '',
          'url': 'https://dev-jts-rh.staging.stonecode.io/admin/',
          'color': '#00897b',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M2 0v16h12V0H2zm6 1.913c.766 0 1.357.626 1.357 1.356S8.765 4.626 8 4.626 6.643 4 6.643 3.27 7.235 1.913 8 1.913zm0 2.922a3.229 3.229 0 013.236 3.234h-6.47A3.227 3.227 0 018 4.835zm4.486 9.009H3.513c-.208 0-.347-.139-.347-.348s.139-.349.347-.349h8.974c.209 0 .349.14.349.349s-.176.348-.35.348zm0-2.678H3.513c-.208 0-.347-.14-.347-.349 0-.208.139-.348.347-.348h8.974c.209 0 .349.14.349.348a.352.352 0 01-.35.349z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'monolith/rh',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'scaf',
          '@type': 'service',
          '@urn': 'jts.registry.service.scaf',
          'id': 'scaf',
          'name': 'SCAF',
          'description': '',
          'url': 'https://dev-jts-scaf.staging.stonecode.io/',
          'color': '#1474ba',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M4.872.93A.208.208 0 005.08.722V.208a.208.208 0 00-.416 0v.515a.206.206 0 00.208.207zM12.309 2.558H7.615c.001-.009.007-.017.007-.028v-.522a.847.847 0 00-1.691 0v.522c0 .01.004.019.006.028h-.216c.002-.009.007-.017.007-.028v-.522a.846.846 0 00-1.69 0v.522c0 .01.004.019.006.028h-.355l-.832.833v11.903h1.666V4.225h6.954v11.069h1.666V3.391l-.834-.833zm-5.968 0c.001-.009.007-.017.007-.028v-.522a.429.429 0 11.856 0v.522c0 .01.005.019.006.028h-.869zM3.723 1.203a.21.21 0 00.295 0 .208.208 0 000-.295L3.654.544a.206.206 0 00-.294 0 .208.208 0 000 .295l.363.364z\'></path><path d=\'M6.022 1.203l.362-.364a.21.21 0 000-.295.208.208 0 00-.295 0l-.363.363a.21.21 0 00.296.296zM8.347 7.052a.876.876 0 00.876-.875.9.9 0 00-.872-.868.895.895 0 00-.885.875.87.87 0 00.881.868zM10.002 14.208c-.268-.798-.527-1.597-.998-2.308-.207-.313-.377-.65-.566-.976a.481.481 0 01-.08-.289c.029-.332.063-.665.109-.995.183.403.361.771.39.824.139.235.27.481.459.679.145.151.33.188.527.106a.485.485 0 00.309-.474.408.408 0 00-.072-.261c-.307-.47-.613-.939-.922-1.408-.021-.03-.238-1.216-.322-1.438a.751.751 0 00-.357-.474.753.753 0 00-.943.15c-.428.464-.852.931-1.279 1.396a.684.684 0 00-.148.242l-.539 1.513a.63.63 0 00-.05.298c.03.23.202.405.438.443a.487.487 0 00.527-.325c.142-.368.271-.741.405-1.113a.084.084 0 00.017-.005l-.009.094-.042.425-.005.051a3.122 3.122 0 00-.018.395c-.02.232-.062 1.707-.078 1.833-.032.247.008.502-.146.736-.367.56-.712 1.132-1.067 1.699-.072.116-.131.234-.124.364.001.252.142.45.372.537a.538.538 0 00.633-.186c.453-.631.895-1.27 1.343-1.905.028-.041.075-.583.103-1.077.09.139.179.278.272.415.1.149.184.304.252.471.263.649.529 1.299.8 1.945.145.347.469.49.793.365.311-.12.453-.443.342-.787-.103-.322-.219-.64-.326-.96z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'monolith/scaf',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'dedicaces',
          '@type': 'service',
          '@urn': 'jts.registry.service.dedicaces',
          'id': 'dedicaces',
          'name': 'Dédicaces',
          'description': '',
          'url': 'https://dev-jts-dedicaces.staging.stonecode.io/',
          'color': '#f9a825',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M15.821 12.641l-.089-.066c-.038-.023-.075-.046-.119-.067a1.942 1.942 0 00-.313-.156c-.238-.112-.552-.209-.924-.269s-.804-.066-1.266-.008c-.231.03-.47.09-.716.164-.06.022-.119.045-.186.067-.06.03-.119.06-.188.089-.059.03-.119.074-.178.104-.06.037-.119.09-.179.142-.201.193-.351.395-.507.596s-.313.402-.484.573a.96.96 0 01-.238.187.52.52 0 01-.066-.126l-.045-.09a2.691 2.691 0 00-.224-.409 3.175 3.175 0 00-.641-.708c-.134-.104-.275-.201-.439-.283s-.35-.149-.581-.172a1.141 1.141 0 00-.38.03.905.905 0 00-.373.201 1.248 1.248 0 00-.134.142l-.067.082-.133.164a5.942 5.942 0 01-.515.588c-.022.022-.044.045-.067.06-.007-.007-.007-.015-.015-.021l-.03-.03c-.037-.037-.074-.075-.112-.111l-.06-.053c-.022-.015-.037-.029-.06-.044l-.119-.082c-.082-.053-.171-.098-.253-.142a2.36 2.36 0 00-1.051-.179 4.37 4.37 0 00-.878.134c-.529.127-.984.29-1.393.432-.41.142-.782.254-1.11.32a3.44 3.44 0 01-.864.09c-.059 0-.119-.008-.171-.015l3.114-1.565a.347.347 0 00.343-.342l-.015-.015 7.725-7.71-.343-.343.715-.723a.389.389 0 000-.544l-.812-.818a.387.387 0 00-.544 0l-.715.723-.392-.397-.306-.32-.351-.365L4.573 5.87l.157.164.804-.418 3.568-3.575.29.306-7.314 7.485-.03-.029a.346.346 0 00-.342.343L0 13.587c0 .037.007.074.015.104L0 13.714s.015.015.045.036a.34.34 0 00.23.172c.112.066.269.156.47.216.268.09.618.149 1.005.142a7.27 7.27 0 001.274-.134c.447-.075.924-.187 1.393-.254.469-.074.939-.089 1.229.038.038.022.075.029.104.052.03.022.075.045.09.067a.176.176 0 00.037.029l.008.008s.007.015.015.015l.037.037.067.074.038.045.037.045.045.045.052.044c.022.016.045.03.06.045a.757.757 0 00.478.127c.215-.015.357-.09.461-.148.208-.127.32-.254.432-.38.216-.246.372-.492.529-.73l.111-.179.06-.09.007-.015c0-.008 0-.008.008-.008.007-.007.029-.007.06-.007.067 0 .164.021.268.067.098.044.202.104.306.171.193.142.373.313.521.514.074.098.134.194.194.298l.044.09c.022.037.037.074.066.119.031.037.053.074.09.119a.89.89 0 00.119.119c.053.037.112.082.194.104.037.015.074.021.119.029a.672.672 0 00.491-.111c.172-.111.275-.224.373-.335.186-.224.335-.447.477-.655.142-.209.275-.418.409-.582.119-.134.321-.253.521-.335a3.09 3.09 0 01.618-.193c.41-.089.813-.112 1.154-.089.09 0 .172.015.254.029s.156.022.23.037l.217.045c.066.015.127.037.186.06.119.037.224.082.306.119.045.022.089.037.127.052.037.022.067.037.097.06.119.067.179.104.179.104L16 12.76c-.008 0-.067-.045-.179-.119z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'dedicaces',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'gesprog',
          '@type': 'service',
          '@urn': 'jts.registry.service.gesprog',
          'id': 'gesprog',
          'name': 'GesProg',
          'description': '',
          'url': 'https://dev-jts-gesprog.staging.stonecode.io/',
          'color': '#f4511e',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M15.169 1.584h-1.157v1.828c0 .785-.642 1.428-1.428 1.428s-1.43-.643-1.43-1.428V1.584H4.845v1.828c0 .785-.643 1.428-1.429 1.428a1.433 1.433 0 01-1.428-1.428V1.584H.832a.833.833 0 00-.832.83v12.818c0 .457.374.83.832.83H15.17a.833.833 0 00.831-.83V2.414a.833.833 0 00-.831-.83M13.554 15H2.444a.833.833 0 01-.831-.83V6.32c0-.457.374-.832.831-.832h11.11c.457 0 .83.375.83.832v7.85a.83.83 0 01-.83.83\'></path><path d=\'M3.416 3.934c.39 0 .707-.315.707-.705V.643a.707.707 0 00-1.412 0v2.586c0 .388.317.705.705.705M12.584 3.934a.705.705 0 00.705-.705V.643a.705.705 0 00-1.411 0v2.586c0 .388.317.705.706.705M5.313 6.844H3.786a.458.458 0 00-.458.457v1.156c0 .254.205.459.458.459h1.527a.459.459 0 00.459-.459V7.301a.459.459 0 00-.459-.457M8.766 6.844h-1.53a.459.459 0 00-.459.457v1.156c0 .254.205.459.459.459h1.528a.46.46 0 00.459-.459V7.301a.458.458 0 00-.457-.457M12.214 6.844h-1.526a.458.458 0 00-.459.457v1.156c0 .254.205.459.459.459h1.526a.458.458 0 00.458-.459V7.301a.457.457 0 00-.458-.457M5.313 9.496H3.786a.458.458 0 00-.458.459v1.154c0 .254.205.459.458.459h1.527a.459.459 0 00.459-.459V9.955a.459.459 0 00-.459-.459M8.766 9.496h-1.53a.459.459 0 00-.459.459v1.154c0 .254.205.459.459.459h1.528a.46.46 0 00.459-.459V9.955a.458.458 0 00-.457-.459M12.214 9.496h-1.526a.458.458 0 00-.459.459v1.154c0 .254.205.459.459.459h1.526a.458.458 0 00.458-.459V9.955a.458.458 0 00-.458-.459M5.313 12.148H3.786a.458.458 0 00-.458.459v1.154c0 .254.205.459.458.459h1.527a.459.459 0 00.459-.459v-1.154a.46.46 0 00-.459-.459M8.766 12.148h-1.53a.459.459 0 00-.459.459v1.154c0 .254.205.459.459.459h1.528a.46.46 0 00.459-.459v-1.154a.459.459 0 00-.457-.459M12.214 12.148h-1.526a.458.458 0 00-.459.459v1.154c0 .254.205.459.459.459h1.526a.458.458 0 00.458-.459v-1.154a.458.458 0 00-.458-.459\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'gesprog',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'agc',
          '@type': 'service',
          '@urn': 'jts.registry.service.agc',
          'id': 'agc',
          'name': 'AGC',
          'description': '',
          'color': '#5e35b1',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M2.574 5.163V3.361L4.755.248H3.112L0 3.361V5.21s.398.89 1.264.89 1.31-.937 1.31-.937zM3.389 5.21s.398.89 1.264.89 1.311-.937 1.311-.937V3.36L6.868.248H5.401L3.389 3.361V5.21zM6.686 5.21s.398.89 1.264.89 1.31-.937 1.31-.937V3.36L8.683.248H7.395l-.709 3.113V5.21zM10.032 5.21s.398.89 1.264.89 1.312-.937 1.312-.937V3.361L10.742.248H9.276l.756 3.113V5.21zM12.848.248h-1.465l2.043 3.113V5.21s.398.89 1.264.89S16 5.163 16 5.163V3.361L12.848.248zM14.476 6.756H1.397a.423.423 0 00-.423.424v8.396c0 .234.19.424.423.424h13.078a.423.423 0 00.423-.424V7.18a.423.423 0 00-.422-.424zm-.846 6.753a.175.175 0 01-.175.175H2.459a.174.174 0 01-.174-.175V8.161c0-.096.078-.174.174-.174h10.996c.097 0 .175.078.175.174v5.348z\'></path></g></svg>',
          'public': false,
          'configurations': {
            'api_endpoint': '',
            'routes': {},
          },
        },
        {
          '@id': 'lsd',
          '@type': 'service',
          '@urn': 'jts.registry.service.lsd',
          'id': 'lsd',
          'name': 'LSD',
          'description': '',
          'url': 'https://dev-jts-lsd.staging.stonecode.io/',
          'color': '#3fb05d',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M2 0v16h12V0H2zm3.9 5.2h.5v-.1-.3h-.5v-.6h.5c.1-.5.3-.9.6-1.2.4-.5 1-.8 1.8-.8.5 0 .9.1 1.2.3l-.2.8c-.2-.2-.6-.3-.9-.3-.4 0-.8.1-1 .4-.3.3-.4.5-.4.8h2.1v.5H7.4v.4h2.2v.5H7.4c.1.4.2.7.4.9.3.3.7.4 1.1.4.4 0 .8-.1 1-.2l.1.7c-.3.2-.7.3-1.2.3-.8 0-1.4-.3-1.9-.8-.2-.3-.4-.7-.5-1.2h-.5v-.5zm6.6 8.6h-9c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h9c.2 0 .3.1.3.3s-.1.3-.3.3zm0-2.6h-9c-.2 0-.3-.1-.3-.3s.1-.3.3-.3h9c.2 0 .3.1.3.3s-.1.3-.3.3z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'lsd',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'gespass',
          '@type': 'service',
          '@urn': 'jts.registry.service.gespass',
          'id': 'gespass',
          'name': 'GesPass',
          'description': '',
          'url': 'https://dev-jts-gespass.staging.stonecode.io/',
          'color': '#a4c400',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M11.963 1.723L10.24 0 7.67 2.571l.928.931L7.329 4.77l-.928-.928-6.4 6.4 1.722 1.722a1.637 1.637 0 012.316 2.316L5.759 16l6.399-6.399-.928-.928 1.272-1.268.927.927 2.572-2.571-1.723-1.723a1.638 1.638 0 11-2.315-2.315zm-.144 4.999l-1.271 1.269-.927-.929 1.269-1.268.929.928zm-1.611-1.61l-1.27 1.269-.927-.927 1.269-1.27.928.928z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'gespass',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'monolith',
          '@type': 'service',
          '@urn': 'jts.registry.service.monolith',
          'id': 'monolith',
          'name': 'Monolith',
          'description': '',
          'url': 'https://dev-jts-monolith.staging.stonecode.io/',
          'color': '',
          'icon': '',
          'public': false,
          'configurations': {
            'api_endpoint': apiEndpoint + 'monolith',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'mercure',
          '@type': 'service',
          '@urn': 'jts.registry.service.mercure',
          'id': 'mercure',
          'name': 'Mercure',
          'description': '',
          'url': '',
          'color': '',
          'icon': '',
          'public': false,
          'configurations': {
            'api_endpoint': mercureEndpoint + '.well-known/mercure',
            'routes': {
              'roles': '',
            },
          },
        },
        {
          '@id': 'shop',
          '@type': 'service',
          '@urn': 'jts.registry.service.shop',
          'id': 'shop',
          'name': 'Boutique',
          'description': '',
          'url': 'https://dev-tickets-japan-expo-com.staging.stonecode.io',
          'color': '#5E35B1',
          'icon': 'data:image/svg+xml;utf8,<svg width=\'36\' height=\'36\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 16 16\'><g style=\'fill: white\'><path d=\'M1.778 0h12.444v1.777H1.778zM12.543 2.568H3.654a.887.887 0 100 1.777h8.889a.888.888 0 100-1.777zM9.877 5.333h1.778V16H9.877zM7.111 5.333h1.778V16H7.111zM4.543 5.333H6.32V16H4.543z\'></path></g></svg>',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'shop',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'code',
          '@type': 'service',
          '@urn': 'jts.registry.service.code',
          'id': 'code',
          'name': 'Code',
          'description': '',
          'url': '',
          'color': '',
          'icon': '',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'code',
            'routes': {
              'roles': '/roles',
            },
          },
        },
        {
          '@id': 'analytics',
          '@type': 'service',
          '@urn': 'jts.registry.service.analytics',
          'id': 'analytics',
          'name': 'Analytics',
          'description': '',
          'url': '',
          'color': '',
          'icon': '',
          'public': true,
          'configurations': {
            'api_endpoint': apiEndpoint + 'analytics',
            'routes': {
              'roles': '/roles',
            },
          },
        },
				{
					'@id': 'network',
					'@type': 'service',
					'@urn': 'jts.registry.service.network',
					'id': 'network',
					'name': 'network',
					'description': '',
					'url': 'https://jts-api.docker.localhost/',
					'color': '',
					'icon': '',
					'public': true,
					'configurations': {
					'api_endpoint': 'https://jts-api.docker.localhost/network',
					'routes': {
						'roles': '/roles',
						},
					},
				},
      ],
	};
}

const AppConfig = window.APP_CONFIG;

export default AppConfig;
